module.exports = __webpack_public_path__ + "media/images/front/materials/papel-70f8f81d74aaa302e6cc3010c221abd0.jpg";